// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"rba-z","disabled":"sba-z","label":"tba-z"};